import { emailServiceApi } from "src/api/email-service";

const sendQuestionEmail = (user, question) => async () => {
  await emailServiceApi.sendQuestionEmail(user, question);
};

export const emailServiceThunks = {
  sendQuestionEmail,
};
